var exports = {
  "ee": "xb99ab02a--89b4b5--mortgage-banner",
  "vW": "xb99ab02a--89b4b5--inner",
  "DD": "xb99ab02a--89b4b5--title",
  "h_": "xb99ab02a--89b4b5--description",
  "wm": "xb99ab02a--89b4b5--logo",
};

module.exports = exports;
